import { ref, watch, onUnmounted, type Ref } from 'vue'

const SITE_NAME = 'UFC Fan Site'

export function useDocumentTitle(title?: string | Ref<string | undefined>) {
  const titleRef = ref(typeof title === 'string' ? title : title?.value)

  const updateTitle = (newTitle: string | undefined) => {
    if (newTitle) {
      document.title = `${newTitle} | ${SITE_NAME}`
    } else {
      document.title = SITE_NAME
    }
  }

  // Initial title set
  updateTitle(titleRef.value)

  // If a reactive ref was passed, watch for changes
  if (title !== undefined && typeof title !== 'string') {
    watch(title, (newValue) => {
      titleRef.value = newValue
      updateTitle(newValue)
    })
  }

  // Update when local ref changes
  watch(titleRef, updateTitle)

  const setTitle = (newTitle: string) => {
    titleRef.value = newTitle
  }

  onUnmounted(() => {
    document.title = SITE_NAME
  })

  return {
    title: titleRef,
    setTitle
  }
}
